import { render, staticRenderFns } from "./publicwelpro.vue?vue&type=template&id=77937d52&scoped=true&"
import script from "./publicwelpro.vue?vue&type=script&lang=js&"
export * from "./publicwelpro.vue?vue&type=script&lang=js&"
import style0 from "./publicwelpro.vue?vue&type=style&index=0&id=77937d52&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77937d52",
  null
  
)

export default component.exports